<div class="daterange">
    <div class="from">
        <label for="fromdt">From</label>
        <input type="datetime-local" id="fromdt" name="fromdt" [(ngModel)]="startDate" (change)="selectionChanged($event, 'start')">
    </div>
    <div class="to">
        <label for="todt">To</label>
        <input type="datetime-local" id="todt" name="todt" [(ngModel)]="endDate"  (change)="selectionChanged($event, 'end')">
    </div>
</div> 